import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { useNavigate, useParams } from 'react-router-dom';

export function PageStripeCheckoutResultViews() {
  //FIELDS

  const navigate = useNavigate();
  const { payment_status } = useParams();

  /*
   * HTML
   */
  return (
    <div className="w-full relative flex h-screen text-center ">
      {payment_status}
      <UI_PRIMITIVE__button variant="outline-on-component" size="sm" onClick={() => navigate(ENUM__page_type.MAIN)}>
        Open app
      </UI_PRIMITIVE__button>
    </div>
  );
}
